import { DataItem } from './details';

export const customerDetailsFields: DataItem[] = [
  { label: 'Name', key: 'fullName' },
  { label: 'Email', key: 'email' },
  { label: 'SMART UID', key: 'userId' },
];

export const remitterDetailsFields: DataItem[] = [
  { label: 'Name', key: 'name' },
  { label: 'Country', key: 'country' },
  { label: 'Address', key: 'address1' },
  { label: 'VAT/TIN/UID', key: 'tinVatUid' },
  { label: 'Email', key: 'email' },
  { label: 'Website', key: 'website' },
];
export const companyDetailsFields: DataItem[] = [
  { label: 'Name', key: 'name' },
  { label: 'Address 1', key: 'address1' },
  { label: 'Country', key: 'country' },
];

export const bankDetailsFields: DataItem[] = [
  { label: 'Bank name', key: 'name' },
  { label: 'SWIFT', key: 'swift' },
  { label: 'Bank address', key: 'legalAddress' },
];

export const companyBeneficiaryDetailsFields: DataItem[] = [
  { label: 'Name', key: 'name' },
  { label: 'Reg. No', key: 'regNo' },
  { label: 'Country', key: 'country' },
];

export const customerDetailsFieldsSmartUID: DataItem[] = [
  { label: 'Name', key: 'fullName' },
  { label: 'Email', key: 'email' },
  { label: 'SMART UID', key: 'smartUID' },
];

export const walletDetailsFields: DataItem[] = [
  { label: 'Name', key: 'name' },
  { label: 'Address', key: 'address' },
  { label: 'Currency', key: 'assetConfig.symbol' },
  { label: 'Network', key: 'network.name' },
];


